import { EventEmitter } from '@angular/core';

import { WidgetType } from '../../../models/widget';

export enum AvailableWidget {
	RTS = 0,
	ISSUE_FOLLOW_UP = 1,
	BIGGEST_STOCKS = 2,
}

export interface WidgetContentChecker {
	currentContent?: unknown;
	content: EventEmitter<unknown>;
}

export interface AvailableWidgetDetails {
	name: string;
	translationKey: string;
	widgetType: WidgetType;
}
